import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { setupInterceptors } from '../api/axiosInstance';

const AuthCallback = () => {
    console.log('AuthCallback');
    const { handleRedirectCallback, getAccessTokenSilently } = useAuth0();
    const navigate = useNavigate();

    useEffect(() => {
        const handleAuthCallback = async () => {
            try {
                await handleRedirectCallback();
                setupInterceptors(getAccessTokenSilently);
                navigate('/');
            } catch (error) {
                console.error('Error during authentication callback handling', error);
            }
        };

        handleAuthCallback();
    }, [handleRedirectCallback, getAccessTokenSilently, navigate]);

    return <div>Loading...</div>;
};

export default AuthCallback;

